import { Tooltip } from '@ads/components-react';
import { ComputerDesktopIcon, DevicePhoneMobileIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import type { ActiveDevice } from '../../../store/atoms/editorUiAtom';

export interface DeviceToggleProps {
  readonly activeDevice: ActiveDevice;
  readonly onDeviceChange: (device: ActiveDevice) => void;
}

export function DeviceToggle({ activeDevice, onDeviceChange }: DeviceToggleProps) {
  const { t } = useTranslation('slideEditor');

  return (
    <div className="flex overflow-hidden rounded-sm border-hairline border-ctx-layout-border">
      <Tooltip side="bottom" title={t('topBar.deviceDesktop')}>
        <button
          type="button"
          onClick={() => onDeviceChange('desktop')}
          className={[
            'flex items-center gap-nano px-nano py-micro !font-medium transition-colors ts-caption-xxs',
            activeDevice === 'desktop'
              ? 'bg-ctx-interactive-primary text-ctx-interactive-primaryAlternative'
              : 'bg-ctx-layout-surface text-ctx-content-base hover:text-ctx-content-title',
          ].join(' ')}
        >
          <ComputerDesktopIcon className="h-micro w-micro" />
        </button>
      </Tooltip>
      <div className="w-[1px] bg-ctx-layout-border" />
      <Tooltip side="bottom" title={t('topBar.deviceMobile')}>
        <button
          type="button"
          onClick={() => onDeviceChange('mobile')}
          className={[
            'flex items-center gap-nano px-nano py-micro !font-medium transition-colors ts-caption-xxs',
            activeDevice === 'mobile'
              ? 'bg-ctx-interactive-primary text-ctx-interactive-primaryAlternative'
              : 'bg-ctx-layout-surface text-ctx-content-base hover:text-ctx-content-title',
          ].join(' ')}
        >
          <DevicePhoneMobileIcon className="h-micro w-micro" />
        </button>
      </Tooltip>
    </div>
  );
}
